type ErrorTag = 'http' | 'nuxt' | 'implementation'

export abstract class ParsedError {
  abstract readonly tag: ErrorTag

  abstract attributes: Record<string, unknown>
}
